import type { SupportedCountry } from '@archipro-website/localisation';
import type { HeaderCountryElement } from '~/utils/country-switch';

interface CountrySuggestionInput {
    siteCountry: SupportedCountry;
    visitorCountry: SupportedCountry | null | undefined;
    /** Market the visitor chose to stay on with "No thanks", if any. */
    pickedCountry: string;
    /** The header country switcher entries, which already carry the target URL. */
    countries: HeaderCountryElement[];
}

/**
 * The country switcher entry to suggest, or null when the visitor is already
 * on their market, is outside our markets, or chose to stay on this site.
 */
export const getCountrySuggestion = ({
    siteCountry,
    visitorCountry,
    pickedCountry,
    countries,
}: CountrySuggestionInput): HeaderCountryElement | null => {
    if (!visitorCountry || visitorCountry === siteCountry) return null;
    if (pickedCountry === siteCountry) return null;
    return countries.find((country) => country.code === visitorCountry) ?? null;
};
